export default [
	{
		path: "/404",
		name: "notFound",
		component: () => import("@views/404.vue"),
	},
	{
		path: "/",
		component: () => import("@views/layout/Main.vue"),
		children: [
			{
				path: "",
				name: "home",
				component: () => import("@views/cites/CitesListView.vue"),
			},
            {
                path: "cites/:citesId",
                name: "citesDetail",
                component: () => import("@views/cites/CitesDetailView.vue"),
            },
		],
	},
	{ path: "/:pathMatch(.*)*", redirect : {name : 'notFound'} }
];
